import {ErrorHandler, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {environment} from '../../environments/environment';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './core.state';
import {FullRouterStateSerializer, RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {EffectsModule} from '@ngrx/effects';
import {AuthEffects} from './stores/auth/effects/auth.effects';
import {AuthInterceptor} from './interceptors/auth.interceptors';
import {CustomSerializer} from './router/custom-serializer';
import {V1HttpErrorInterceptor} from './interceptors/v1-http-error-interceptor.service';
import {AppErrorHandler} from './error-handlers/app-error-handler.service';

export const HttpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(
  http,
  `${environment.i18nPrefix}/assets/i18n/`,
  '.json'
);

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,

    StoreModule.forRoot(reducers, {metaReducers}),
    StoreRouterConnectingModule.forRoot({serializer: FullRouterStateSerializer}),
    EffectsModule.forRoot([
      AuthEffects
    ]),

    environment.production ? [] : StoreDevtoolsModule.instrument({name: 'ClassificaOnline', maxAge: 30, connectInZone: true}),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: V1HttpErrorInterceptor, multi: true},
    {provide: ErrorHandler, useClass: AppErrorHandler},
    {provide: RouterStateSerializer, useClass: CustomSerializer}
  ],
  exports: [TranslateModule]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
      parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
